export default "__VITE_PUBLIC_ASSET__51f4c9a8__"